import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../components";
import { getCustomerInfo } from "../../server/axios";
import { CUSTOMER_PRE_INFO, CUSTOMER_UPDATER } from "../../routes/path";
import store from "../../store";
import getLineProfile from "../../utils/getLineProfile";
import { setFamiliesData } from "../../store/actions/prescription";

/**
 * 利用者情報登録画面
 * @returns
 */
const IsNewCustomerHandler = () => {
  const navigate = useNavigate();
  // to avoid render twice locally from react strict mode
  const firstRenderRef = useRef(true);

  const getData = (lineId) => {
    getCustomerInfo({ lineId }).then((res) => {
      if (res.data.isNew) {
        navigate(CUSTOMER_PRE_INFO);
      } else {
        store.dispatch(setFamiliesData(res.data.families));
        navigate(CUSTOMER_UPDATER, { state: res.data });
      }
    });
  };

  useEffect(() => {
    // to avoid render twice locally from react strict mode
    if (process.env.NODE_ENV === "development" && firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }
    const selectLineInfo = (state) => state.prescription.lineInfo;
    const lineInfo = selectLineInfo(store.getState());
    if (lineInfo.lineId) {
      getData(lineInfo.lineId);
    } else {
      getLineProfile().then((profile) => {
        getData(profile.userId);
      });
    }
  }, []);

  return <Loading open={true} />;
};

export default IsNewCustomerHandler;
